/**
 * Truncates text to a maximum length and adds an ellipsis if the text is longer than the maximum length.
 *
 * @param text - The text to truncate.
 * @param maxLength - The maximum length of the text.
 * @returns The truncated text.
 */

export const truncateText = (text: string, maxLength: number = 20) => {
  if (text?.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};
